import { render, staticRenderFns } from "./page-title.vue?vue&type=template&id=4406d506&scoped=true&"
import script from "./page-title.ts?vue&type=script&lang=ts&"
export * from "./page-title.ts?vue&type=script&lang=ts&"
import style0 from "./page-title.scss?vue&type=style&index=0&id=4406d506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4406d506",
  null
  
)

export default component.exports